import { render, staticRenderFns } from "./IndexMapPlants.vue?vue&type=template&id=60dd9227&scoped=true&lang=pug&"
import script from "./IndexMapPlants.vue?vue&type=script&lang=ts&"
export * from "./IndexMapPlants.vue?vue&type=script&lang=ts&"
import style0 from "./IndexMapPlants.vue?vue&type=style&index=0&id=60dd9227&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd9227",
  null
  
)

export default component.exports